import React from 'react';
import './Event_about.css';
import arrow from '../../img/event_arrow.svg'
import creative from '../../img/main/creative.png'
import logo_geekle from '../../img/logo.png'

const FAQ = (props) => {
    const state = {
        About_item: [
            {
                text: `Software development engineers in test (SDETs) as a practice and career path`,
            },
            {
                text: `Agile and DevOps in Testing`,
            },
            {
                text: `Artificial Intelligence in QA`,
            },
            {
                text: `Gain a deeper understanding of mobile testing`,
            },
            {
                text: `Scale Test Automation`,
            },
            {
                text: `How to establish metrics to track testing`,
            },
            {
                text: `The concept of Rapid Software Testing`,
            },
            {
                text: `Testing for the Internet of Things (IoT)`,
            },
            {
                text: `Discover codeless test automation`,
            },
            {
                text: `Testing in Blockchain and Web3`,
            },
            {
                text: `Dive into Robotic Process Automation`,
            },
            {
                text: `Discover new patterns and mindsets for microservices testing`,
            },
        ],
        details: [
            {
                topic: 'Type',
                value: 'topics',
            },
            {
                topic: 'Priority',
                value: 'High',
            },
            {
                topic: 'Labels',
                value: 'Junior/Senior',
            },
            {
                topic: 'Sprint',
                value: '2022.2',
            },
        ]
    };

    const renderAboutItem = (item, i) => {
        return (
            <li className='about_details_text'>- {item.text}</li>
        );
    };

    const renderDetails = (item, i) => {
        return (
            <li className='about_details_text'><span className='about_details_text--topic'>{item.topic}:</span> {item.value}</li>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h2 className="about_title">What event is about</h2>
                <div className="about_blocks">
                    <div className='about_terminal--header'>
                        <div className='about_terminal--tab about_terminal--tab_logo-block'>
                            <img className='about_terminal--logo' src={creative} alt="" />
                        </div>
                        <div className='about_terminal--tab about_terminal--tab_mob'>
                            <p className='about_terminal--title'>Projects</p>
                            <img className='about_terminal--img' src={arrow} alt="" />
                        </div>
                        <div className='about_terminal--tab about_terminal--tab_mob'>
                            <p className='about_terminal--title'>Issues</p>
                            <img className='about_terminal--img' src={arrow} alt="" />
                        </div>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>Tests</p>
                            <img className='about_terminal--img' src={arrow} alt="" />
                        </div>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>Reports</p>
                            <img className='about_terminal--img' src={arrow} alt="" />
                        </div>
                    </div>
                    <div className='about_terminal--body'>
                        <div className='about_terminal--body_user'>
                            <img className='about_terminal_user-ava' src={logo_geekle} alt="" />
                            <p className='about_terminal_user-topic'>Topic report</p>
                        </div>
                        <div className='about_terminal_details_block about_terminal_details_block--border'>
                            <p className='about_terminal_details_topic'>Details</p>
                            <ul>
                                {state.details.map((item, i) => renderDetails(item, i))}
                            </ul>
                        </div>
                        <div className='about_terminal_details_block'>
                            <p className='about_terminal_details_topic'>Description</p>
                            <ul>
                                {state.About_item.map((item, i) => renderAboutItem(item, i))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;